// src/utils/schedule.js

// treat "", "-", "—", "NA", "N/A" as blanky
const isBlanky = (v) => {
  const s = String(v ?? "").trim().toUpperCase();
  return s === "" || s === "-" || s === "—" || s === "NA" || s === "N/A";
};

export function getStatus(m) {
  const hs = String(m?.home_score ?? "").trim();
  const as = String(m?.away_score ?? "").trim();
  const noScore = isBlanky(hs) && isBlanky(as);
  return noScore ? "Upcoming" : "Final";
}

// Sort by ascending start time (undefined => bottom)
export function sortByStartAsc(a, b) {
  const ad = a?._start?.getTime?.() ?? Number.POSITIVE_INFINITY;
  const bd = b?._start?.getTime?.() ?? Number.POSITIVE_INFINITY;
  return ad - bd;
}

// Parse YYYY-MM-DD + time (“HH:mm” or “h:mm AM”), fallback safe
export function dtFromStrings(dateStr, timeStr = "00:00") {
  try {
    const d = (dateStr || "").trim();
    const t = (timeStr || "00:00").trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(d)) {
      const dt1 = new Date(`${d} ${t}`);
      if (!isNaN(dt1)) return dt1;
      const dt2 = new Date(`${d}T${t}`);
      if (!isNaN(dt2)) return dt2;
    }
    const any = new Date(`${d} ${t}`);
    if (!isNaN(any)) return any;
  } catch {}
  // put undated items last
  return new Date("9999-12-31T23:59:59Z");
}

export const SAMPLE_MATCHES = [];
